import Glide from "@glidejs/glide"

document.addEventListener("DOMContentLoaded", () => {
  initDetails()
  initSliders()
})

function initDetails() {
  const allDetails = document.querySelectorAll(
    "details.drawers-and-organizers-details",
  )
  if (!allDetails || allDetails.length === 0) {
    return
  }

  const handleDetailsToggle = (event) => {
    const currentDetails = event.currentTarget

    if (currentDetails.open) {
      allDetails.forEach((otherDetails) => {
        if (otherDetails !== currentDetails) {
          otherDetails.open = false
        }
      })
    }
  }

  allDetails.forEach((details) => {
    details.addEventListener("toggle", handleDetailsToggle)
  })
  allDetails[0].open = true
}

function toggleActive(element, active) {
  const className = "drawers-and-organizers-navigation__active"
  const containsClass = element.classList.contains(className)
  if ((active && !containsClass) || (!active && containsClass)) {
    element.classList.toggle(className)
  }
}

function addNavigationActiveListeners(elementsActive, elementsInactive) {
  elementsActive.forEach((element) => {
    element.addEventListener("click", () => {
      elementsActive.forEach((element) => toggleActive(element, true))
      elementsInactive.forEach((element) => toggleActive(element, false))
    })
  })
}

const navButtonsDrawers = document.getElementsByClassName(
  "navigation-button-drawers",
)
const navButtonsOrganizers = document.getElementsByClassName(
  "navigation-button-organizers",
)

if (navButtonsDrawers.length && navButtonsOrganizers.length) {
  addNavigationActiveListeners(navButtonsDrawers, navButtonsOrganizers)
  addNavigationActiveListeners(navButtonsOrganizers, navButtonsDrawers)
}

function initSliders() {
  const sliders = document.querySelectorAll(
    ".glide.glide-drawers-and-organizers",
  )
  for (let i = 0; i < sliders.length; i++) {
    if (sliders[i]) {
      new Slider(sliders[i])
    }
  }
}

class Slider {
  constructor(sliderContainer) {
    this.sliderContainer = sliderContainer
    this.slider = new Glide(sliderContainer, {
      type: "carousel",
      perView: 1,
      gap: 0,
      autoplay: false,
      // autoplay: 3000,

      hoverpause: false,
      animationDuration: 500,
      keyboard: false,
    }).mount()

    this.handleClickEvents()
  }

  handleClickEvents() {
    this.sliderContainer.addEventListener("click", (e) => {
      if (e.target.classList.contains("hero-link")) return
      const clientX = e.clientX
      const centerPointX = this.sliderContainer.clientWidth / 2

      if (clientX < centerPointX) {
        this.slider.go("<")
      } else {
        this.slider.go(">")
      }
    })
  }
}
